<mat-dialog-content class="app-dialog-container error-dialog">
    <div class="app-dialog-header">
        <div class="app-dialog-header-text">An Error Has Occurred</div>
        <button type="button" class="app-dialog-header-close-button" (click)="close()">
            <i class="fas fa-times"></i>
        </button>
    </div>
    <div>
        <p class="error-dialog-text">
            Please copy the error details and report this issue to IT and try again later.
        </p>
        <p class="error-dialog-text">
            <button type="button"
                    class="button-flat"
                    (click)="copyErrorDetails()">
                <i class="fas fa-copy"></i> COPY ERROR DETAILS
            </button>
        </p>
        <p class="error-dialog-text error-dialog-pre">{{errorDetails}}</p>
    </div>
</mat-dialog-content>
